export default {
  // setIsSchedule(state, data) {
  //   state.isSchedule = data
  // }
}